/// <reference path="../../typings/browser.d.ts" />

namespace Application.Directives {
    'use strict';

    import Utils = Application.Common.Utils;
    declare type DevicePropertyDirectiveFactoryCb = () => DevicePropertyDirective;

    interface IDevicePropertyDirectiveScopeDef {
        id: string;
        name: string;
        value: string;
        list: string;
        format: string;  // bitrate
        capitalize: string;
    }

    interface IDevicePropertyDirectiveScope extends ng.IScope {
        name: string;
        value: number | string | boolean;
        list: string;
        format: string;
        capitalize: string;

        valueToShow: number | string | boolean | string[];
        fullValue: string;
        isList: () => boolean;
        isEmpty: () => boolean;
        isHidden: () => boolean;
        copyToClipBoard: (elementId: string) => void;
        copyToVLC: (elementId: string) => void;
    }

    export class DevicePropertyDirective implements ng.IDirective {
        public static $name: string = 'deviceProperty';

        public link: ($scope: IDevicePropertyDirectiveScope, $element: JQuery, attrs: ng.IAttributes) => void;
        public restrict: string = 'E';
        public replace: boolean = true;
        public templateUrl: string = 'decorators/device-property-directive.html';
        public scope: IDevicePropertyDirectiveScopeDef = {
            id: '@',
            name: '@',
            value: '=',
            list: '@?',
            format: '@?',
            capitalize: '@?',
        };

        /**
         * Factory for the directive
         */
        public static Factory(): DevicePropertyDirectiveFactoryCb {
            let directive: DevicePropertyDirectiveFactoryCb = () => {
                return new DevicePropertyDirective();
            };
            directive.$inject = [];
            return directive;
        }

        /**
         * Constructor
         */
        constructor() {
            DevicePropertyDirective.prototype.link = ($scope: IDevicePropertyDirectiveScope, $element: JQuery, attrs: ng.IAttributes) => {
                if ($scope.capitalize == undefined ) {
                    $scope.capitalize = 'true';
                }

                $scope.isList = (): boolean => {
                    return typeof $scope.valueToShow === 'object' && $scope.valueToShow.length > 0;
                };

                $scope.isEmpty = (): boolean => {
                    return $scope.isList() ? !$scope.valueToShow[0] : $scope.valueToShow === '' || $scope.valueToShow === undefined;
                };

                $scope.isHidden = (): boolean => {
                    return $scope.name === 'hidden';
                };

                $scope.$watch('value', (newVal: number | string | boolean, oldVal: number | string | boolean) => {
                    if ((newVal !== oldVal && newVal !== undefined) || (newVal !== undefined && !$scope.valueToShow))
                        this.formatValue($scope, newVal);
                });

                $scope.copyToClipBoard = (elementId: string) => {
                    const copyText: HTMLInputElement = document.getElementById(elementId) as HTMLInputElement;
                    copyText.select();
                    document.execCommand("copy");
                };

                $scope.copyToVLC = (elementId: string) => {
                    const devicePlatform: string = Utils.getDevicePlatform();

                    if (devicePlatform !== 'UNKNOWN') {
                        const srtElement: HTMLInputElement = document.getElementById(elementId) as HTMLInputElement;
                        const srtText: string = srtElement.value;
                        const splittedUrl: string[] = srtText.split('?');
                        const urlText: string = splittedUrl[0];

                        const params: { [key: string]: string; } = Utils.parseQueryString(splittedUrl[1]);
                        const vlcScript: string = Utils.generateVLCScript(urlText, params, devicePlatform);

                        if (vlcScript !== undefined) {
                            Utils.copyToClipboard(vlcScript);
                        }
                    }
                };
            };
        }

        private formatValue($scope: IDevicePropertyDirectiveScope, newVal: number | string | boolean): void {
            if (typeof newVal === 'string' && $scope.capitalize == 'true') { // Make first letter uppercase
                newVal = newVal ? newVal[0].toUpperCase() + newVal.slice(1) : "";
            }
            if ($scope.list === 'true') {
                let arrayVal: Array<string> = (newVal as string).split(', ');
                if (arrayVal.length >= 2) {
                    arrayVal[1] = arrayVal[1].replace(/^\s\|\s$/g, ""); // Remove things like " | " 
                }                                                       // that happens when we don't have audio vals
                $scope.valueToShow = arrayVal;
            } else {
                if ($scope.format && $scope.format === 'bitrate') {
                    $scope.valueToShow = ((newVal as number) / 1000000) + " Mbps";
                } else if ($scope.format && $scope.format.indexOf("max:") === 0) {
                    const maxLength: number = +$scope.format.split(":")[1];
                    let valueToShow: string = ((newVal as string));
                    if (valueToShow.length > maxLength) {
                        valueToShow = valueToShow.substring(0, maxLength) + "...";
                        $scope.valueToShow = valueToShow;
                        $scope.fullValue = ((newVal as string));
                    }
                } else {
                    const valueToShow: number | string | boolean | string[] = (typeof newVal === 'string') ?
                                                                             (newVal as string).replace(/([,-]\s)?[,-]\s*$/, "") : newVal;
                    $scope.valueToShow = (valueToShow !== " " && valueToShow !== "N/A" ) ? valueToShow : "";
                }
            }
        }
    }
}